<button
  appearance="flat"
  class="pointer-events-auto md:hidden!"
  data-testid="sidebar-show-button"
  iconStart="@tui.menu"
  size="s"
  tuiIconButton
  type="button"
  (click)="showSidebar()"></button>

<button
  appearance="flat"
  class="pointer-events-auto max-md:hidden!"
  data-testid="sidebar-toggle-button"
  iconStart="@tui.menu"
  size="s"
  tuiIconButton
  type="button"
  (click)="toggleSidebarCollapsed()"></button>

<a appearance="flat" class="pointer-events-auto md:hidden!" routerLink="/home" size="s" tuiIconButton>
  <img class="p-1" src="https://cdn.pixacare.com/logo/mire.svg" />
</a>

@let visible = (visible$ | async) ?? false;
@let backLink = backLink$ | async;

@if (backLink) {
  <div animateDirection="bottom" [animateFade]="visible">
    <button
      appearance="outline"
      backButton
      data-testid="back-button"
      iconStart="@tui.chevron-left"
      size="s"
      tuiHint="Retour"
      tuiHintDescribe
      tuiHintDirection="bottom"
      tuiIconButton
      type="button"
      [defaultBackUrl]="backLink"
      [ngClass]="{
        'pointer-events-none': !visible,
        'pointer-events-auto': visible,
      }"></button>
  </div>
}

<button
  animateDirection="bottom"
  class="pointer-events-auto flex-1 truncate px-1 text-left font-medium"
  type="button"
  [animateFade]="visible"
  [disabled]="!visible"
  (click)="scrollToTop()">
  {{ title$ | async }}
</button>

<div class="ml-auto flex items-center pointer-events-auto">
  @if (hasLongVideoEnabledClient()) {
    <pxc-video-upload-sync-center-button data-testid="sync-center-button" />
  }

  <button
    appearance="flat"
    iconStart="@tui.circle-help"
    size="s"
    tuiDropdownAuto
    tuiIconButton
    type="button"
    [tuiDropdown]="helpMenuActions"></button>
</div>

<ng-template #helpMenuActions>
  <pxc-menu-actions [actions]="helpActions" />
</ng-template>
